import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { Box, Card, Chip, IconButton, Stack, Typography } from "@mui/material";

import AddIcon from "@mui/icons-material/Add";
import PlaceIcon from "@mui/icons-material/Place";

import { Postrequestcall } from "../../request/Postrequest";
import { FETCH_CLIENT_SAFETY_INCIDENT } from "../../constant/Apipath";

import InfiniteScroll from "react-infinite-scroll-component";
import Loader from "../../common/Loader";
import AddClientSafetyIncident from "./ClientSafetyIncidentAddModal";
import ViewClientSafetyIncident from "./ClientSafetyIncidentViewModel";
import { ClientEnglishFallback } from "../constant/ClientEnglishFallback";
import { useLocation } from "react-router-dom";

function ClientSafetyIncident() {
  const { loginData, multiLanguageData, selectedClientData } = useSelector((state) => state?.main);
  const { TEXT_CLIENT_NOTIFIELD, TEXT_YOU_HAVE_NOT_SUBMITTED_ANY_INCIDENTS_YET } =
    ClientEnglishFallback.ClientSaftyIncident(multiLanguageData?.ClientSaftyIncident || {});
  const [safetyIncidentData, setSafetyIncidentData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [hasMore, setHasMore] = useState(true);
  const [pageNo, setPageNo] = useState(1);
  const [currentSafetyIncident, setCurrentSafetyIncident] = useState([]);
  const [viewSafetyIncident, setViewSafetyIncident] = useState(false);
  const [viewAddModel, setViewAddModel] = useState(false);
  const location = useLocation();

  useEffect(() => {
    getSafetyIncidentData(1);
  }, [location]);

  const getSafetyIncidentData = async (pageNo) => {
    setIsLoading(true);
    try {
      const obj = {
        PageNr: pageNo,
        NrOfRecPerPage: 30,
        FullSearch: location?.state?.searchText || "",
        UserId: loginData?.userInformation?.UserId,
        IncludeRecordNr: true,
        FetchAllowedRecordsOnly: true,
        SearchList: [
          {
            ModifiedBy: loginData?.userInformation?.UserId,
            clientEmployeeId: selectedClientData?.ClientEmployeeId
          }
        ],
        SortList: [
          {
            FieldName: "incidentDate",
            Direction: "DESC"
          }
        ]
      };
      const safetyIncidentResponse = await Postrequestcall(
        FETCH_CLIENT_SAFETY_INCIDENT,
        obj,
        loginData?.accessToken
      );
      if (safetyIncidentResponse?.status === 200) {
        if (pageNo === 1) {
          setSafetyIncidentData(safetyIncidentResponse?.data?.data);
        } else {
          setSafetyIncidentData((prevData) => [...prevData, ...safetyIncidentResponse?.data?.data]);
        }
        setPageNo(pageNo + 1);
        if (safetyIncidentResponse?.data?.data?.length === 0) {
          setHasMore(false);
        } else {
          setHasMore(true);
        }
      }
    } catch (error) {
      setIsLoading(false);
      console.log("getSafetyIncidentData-> Error Fetching Client Safety Incident Data: ", error);
    }
    setIsLoading(false);
  };

  const handleShowViewModel = (data) => {
    setViewSafetyIncident(true);
    setCurrentSafetyIncident(data);
  };

  const handleHideViewModel = () => {
    setViewSafetyIncident(false);
    setCurrentSafetyIncident([]);
  };

  const handleToggleAddModel = async (load) => {
    setViewAddModel(!viewAddModel);
    if (load === true) {
      await getSafetyIncidentData(1);
    }
  };

  const CustomListing = ({ data, index }) => {
    return (
      <Card
        key={index}
        className="client-card"
        sx={{ marginTop: "10px" }}
        onClick={() => handleShowViewModel(data)}>
        <Stack spacing={2}>
          <Stack direction="row" justifyContent="space-between" alignItems="center" width="100%">
            <Stack direction="row" alignItems="center" spacing={1}>
              <PlaceIcon sx={{ color: selectedClientData?.AccentColor }} />
              <Typography variant="p">
                {data?.clientJobCode}
                {" - "}
                {data?.clientJobName}
              </Typography>
            </Stack>
            <Typography variant="body1" color="textDisabled">
              {dayjs(data.incidentDate).format("MMMM DD, YYYY")}
            </Typography>
          </Stack>

          <Typography variant="body1">{data?.description}</Typography>
        </Stack>

        {data?.udFieldsList?.[0]?.value === "true" && <Chip label={data?.udFieldsList?.[0]?.label} />}
      </Card>
    );
  };

  return (
    <>
      <Box>
        {isLoading && safetyIncidentData?.length == 0 ? (
          <Loader fullScreen />
        ) : safetyIncidentData?.length > 0 ? (
          <>
            <InfiniteScroll
              dataLength={safetyIncidentData?.length}
              next={() => getSafetyIncidentData(pageNo)}
              hasMore={hasMore}
              loader={<Loader />}>
              {safetyIncidentData?.map((data, index) => (
                <CustomListing key={index} index={index} data={data} />
              ))}
            </InfiniteScroll>
          </>
        ) : (
          <Stack sx={{ width: "100%" }} justifyContent="center" alignItems="center" height="85vh">
            <Typography>{TEXT_YOU_HAVE_NOT_SUBMITTED_ANY_INCIDENTS_YET}</Typography>
          </Stack>
        )}
      </Box>
      {viewSafetyIncident && (
        <ViewClientSafetyIncident
          open={viewSafetyIncident}
          handleClose={handleHideViewModel}
          currentSafetyIncident={currentSafetyIncident}
        />
      )}
      {viewAddModel && (
        <AddClientSafetyIncident open={viewAddModel} handleClose={handleToggleAddModel} />
      )}
      <div className="button-div">
        <IconButton
          className="icon-button"
          sx={{ backgroundColor: selectedClientData?.AccentColor }}
          onClick={handleToggleAddModel}>
          <AddIcon className="add-icon" />
        </IconButton>
      </div>
    </>
  );
}

export default ClientSafetyIncident;
